import { render, staticRenderFns } from "./Godnatt.vue?vue&type=template&id=6bc972ee"
import script from "./Godnatt.vue?vue&type=script&lang=js"
export * from "./Godnatt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports